<template>
  <div class="page">
    <div class="department-main">
      <div class="department-item">
        <div class="department-key">组织架构:</div>
        <div class="department-val">
          <b-organize-department isEdit isInit @success="getDepartmentActiveList" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      departmentLastId: '',
      departmentActiveList: [],
      departmentActiveIds: []
    }
  },
  computed: {
    // 部门末级选中对象
    departmentLastActiveObj() {
      let result = ''
      let len = this.departmentActiveList.length
      if (len) result = this.departmentActiveList[len - 1]
      return result
    }
  },
  watch: {
    departmentLastActiveObj(newVal, oldVal) {
      if (newVal.id !== oldVal.id) {
        if (newVal.has_children) {
          this.departmentLastId = ''
        } else {
          this.departmentLastId = newVal.id
        }
      }
    }
  },
  methods: {
    // 获取选中部门列表
    getDepartmentActiveList(list) {
      this.departmentActiveList = []
      this.departmentActiveIds = []
      list.forEach((itemSt) => {
        itemSt.category.forEach((itemNd) => {
          if (itemSt.title.active_id === itemNd.id) {
            this.departmentActiveList.push(this.$util.deepCopy(itemNd))
            this.departmentActiveIds.push(itemNd.id)
          }
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
.page {
  padding-bottom: 10px;
  .department-main {
    .department-item {
      display: flex;
      & ~ .department-item {
        margin-top: 10px;
      }
      .department-key {
        width: 108px;
        margin-right: 5px;
        line-height: 28px;
        text-align: right;
      }
      .department-val {
        flex: 1;
        display: flex;
        align-items: center;
      }
    }
  }
}
</style>
